import { makeRoute } from './makeRoute';

export const home = makeRoute(() => `/`, 'marketing');
export const about = makeRoute(() => `/about`, 'marketing');
export const donors = makeRoute(() => `/donors`, 'marketing');
export const orgs = makeRoute(() => `/orgs`, 'marketing');
export const advisors = makeRoute(() => `/advisors`, 'marketing');
export const institutions = makeRoute(() => `/institutions`, 'marketing');
export const otc = makeRoute(() => `/otc`, 'marketing');
export const donationCalculator = makeRoute(() => `/calculators/donation`, 'marketing');
export const whatMakesAGoodGift = makeRoute(() => `/what-makes-a-good-gift`, 'marketing');
export const impact = makeRoute((args: { year?: number }) => {
  if (!args.year) return `/impact`;
  return `/impact/${args.year}`;
}, 'marketing');
export const _404 = makeRoute(() => `/404`, 'marketing');

/*
 * The refreshed sitemap (IS-26020). These describe the App and the API on the
 * marketing site; routes.app.* is the product itself.
 */
export const app = makeRoute(() => `/app`, 'marketing');
export const api = makeRoute(() => `/api`, 'marketing');
export const learn = makeRoute(() => `/learn`, 'marketing');

/*
 * The booking calendars behind the App page's two "talk to us" buttons
 * (IS-35113). Plain absolute URLs rather than makeRoute: Calendly is not one of
 * our apps and has no base URL in config to sit behind.
 *
 * Which calendar each button gets is a question of who is free, not of what the
 * button means. These two are the answer for now, with Zach out: the partner
 * conversation goes to the calendar he is not on, and Giving Services goes to
 * the Request a Demo calendar. Change the URL here when the roster does.
 */
export const bookPartnerCall = () => 'https://calendly.com/d/csbx-9p7-sgp/noah-bruxa';
export const bookGivingServices = () => 'https://calendly.com/d/cj8s-j7w-q2k/request-a-demo-with-endaoment';
